'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import Languages from '../constants/Languages';
import LanguageUtil from '../util/LanguageUtil';
import { getLocalizedUrl } from '../util/Urls';

var LanguageSwitchPopup = /*#__PURE__*/function (_React$Component) {
  _inherits(LanguageSwitchPopup, _React$Component);

  function LanguageSwitchPopup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LanguageSwitchPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LanguageSwitchPopup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderCheck = function (language) {
      return LanguageUtil.getUserLanguage() === language ? /*#__PURE__*/_jsx("span", {
        className: "icon icon-check"
      }) : undefined;
    };

    _this.renderLanguages = function () {
      return Object.keys(Languages).map(function (languageKey, index) {
        var language = Languages[languageKey];
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsxs("a", {
            className: "language-switcher-link",
            href: getLocalizedUrl(languageKey),
            children: [_this.renderCheck(languageKey), language]
          })
        }, index);
      });
    };

    return _this;
  }

  _createClass(LanguageSwitchPopup, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var ulClassNames = props.isOpen ? "open" : "";
      return /*#__PURE__*/_jsx("ul", {
        className: ulClassNames,
        children: this.renderLanguages()
      });
    }
  }]);

  return LanguageSwitchPopup;
}(React.Component);

LanguageSwitchPopup.propTypes = {
  isOpen: PropTypes.bool
};
export default LanguageSwitchPopup;